import React from 'react';
import { StandardBanner, StandardBannerProps } from '@noths/polaris-client-ribbons-design-system';

import { trackLinkClick } from '../../../tracking/common/banner';
import { trackImpression } from '../../../tracking/common/trackImpression';
import { TrackingContext } from '../../../types/TrackingContext';
import { BlockContainer } from '../BlockContainer/BlockContainer';
import * as styles from './StandardBannerBlock.style';

export interface StandardBannerBlockProps extends StandardBannerProps {
  trackingTitle: string;
  trackingPosition?: number;
}

export const StandardBannerBlock = ({
  trackingPosition,
  trackingTitle,
  ...restOfProps
}: StandardBannerBlockProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Standard banner',
  };

  return (
    <BlockContainer wrapperStyles={styles.wrapper} maxWidth="full">
      <StandardBanner
        onVisible={() => trackImpression(trackingContext)}
        onLinkClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
          trackLinkClick(e, trackingContext, 'Link')
        }
        {...restOfProps}
      />
    </BlockContainer>
  );
};

export type { StandardBannerProps };
